import React from 'react';
import {Link} from 'react-router';
import {
  ROUTE_CONTACT, ROUTE_FRIENDS, ROUTE_HIRING, ROUTE_INTRODUCTION, ROUTE_MEDIA,
  ROUTE_PERFORMANCES
} from '../../constants'

const SiteMap = () => {

  return (
    <div>

      <div className="row">

        <div className="col s12 m6 l4">
          <Link activeClassName={'active'} to={ROUTE_INTRODUCTION}>
            <div className="center promo promo-example">
              <i className="material-icons">supervisor_account</i>
              <p className="promo-caption">Présentation</p>
              <p className="light center">La fanfare Mouv' your Baudet, c'est quoi ?</p>
            </div>
          </Link>
        </div>

        <div className="col s12 m6 l4">
          <Link activeClassName={'active'} to={ROUTE_PERFORMANCES}>
            <div className="center promo promo-example">
              <i className="material-icons">event</i>
              <p className="promo-caption">Prestations</p>
              <p className="light center">Découvrez les évènements fanfare passés et futurs du Baudet !</p>
            </div>
          </Link>
        </div>

        <div className="col s12 m6 l4">
          <Link activeClassName={'active'} to={ROUTE_MEDIA}>
            <div className="center promo promo-example">
              <i className="material-icons">perm_media</i>
              <p className="promo-caption">Médias</p>
              <p className="light center">Le répertoire musical de la fanfare, les photos et les vidéos : vous allez en prendre plein les oreilles !</p>
            </div>
          </Link>
        </div>

        <div className="col s12 m6 l4">
          <Link activeClassName={'active'} to={ROUTE_FRIENDS}>
            <div className="center promo promo-example">
              <i className="material-icons">group</i>
              <p className="promo-caption">Amis</p>
              <p className="light center">Une liste non exhaustive des fanfares amies du Baudet :)</p>
            </div>
          </Link>
        </div>

        <div className="col s12 m6 l4">
          <Link activeClassName={'active'} to={ROUTE_HIRING}>
            <div className="center promo promo-example">
              <i className="material-icons">star</i>
              <p className="promo-caption">Recrutement</p>
              <p className="light center">Tu aimes la fanfare Mouv' your Baudet et tu veux en faire parti ? C'est par ici !</p>
            </div>
          </Link>
        </div>

        <div className="col s12 m6 l4">
          <Link activeClassName={'active'} to={ROUTE_CONTACT}>
            <div className="center promo promo-example">
              <i className="material-icons">mail</i>
              <p className="promo-caption">Contact</p>
              <p className="light center">Besoin de contacter la fanfare ? Un formulaire tout neuf t'attend, ainsi que nos coordonnées.</p>
            </div>
          </Link>
        </div>

      </div>


    </div>
  );

}

export default SiteMap;



/** WEBPACK FOOTER **
 ** ./src/components/Home/SiteMap.js
 **/